export const QUOTA_LEVEL = { OK: 'ok', WARNING: 'warning', FULL: 'full' }

const WARNING_THRESHOLD_PERCENT = 80

// max<=0 은 "미할당"(관리자가 아직 quota 를 배정하지 않음) — 생성 불가 상태이므로 full 로 취급
export function getQuotaStatus(current, max) {
  const safeCurrent = Number(current) || 0
  const safeMax = Number(max) || 0

  if (safeMax <= 0 || safeCurrent >= safeMax) {
    return { percent: 100, level: QUOTA_LEVEL.FULL }
  }

  const rawPercent = (safeCurrent / safeMax) * 100
  const percent = Math.min(100, Math.max(0, rawPercent))

  if (rawPercent >= WARNING_THRESHOLD_PERCENT) {
    return { percent, level: QUOTA_LEVEL.WARNING }
  }

  return { percent, level: QUOTA_LEVEL.OK }
}
